export const FORM_NAME = 'ABSTRACT_REVENUE_BUDGET_FORM';

export enum BUDGET_TYPE {
    REVENUE = 'REVENUE',
    OCCUPANCY = 'OCCUPANCY',
}
